import React from 'react'
import { Box, Container, Typography, Grid, Avatar } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const TestimonialsSection = () => {
  const theme = useTheme()

  const testimonials = [
    {
      id: 1,
      quote: "Getting in on the ground floor of MyStethi has been exciting. The site provides ",
      highlight: "direct connection between hospital in-house recruiters and candidates seeking jobs",
      quoteEnd: ". I've only been a subscriber for a few months and recently interviewed and extended an offer to an excellent candidate. Aleksey has been prompt to respond to questions and is proactive with ideas to further improve the site.",
      name: "Jody Long",
      title: "Recruitment Supervisor",
      organization: "Sarah Bush Lincoln Health Center",
      avatar: "/static/images/avatars/jody-long.jpg",
      highlightColor: {
        background: theme.palette.warning.light,
        text: theme.palette.warning.dark
      }
    },
    {
      id: 2,
      quote: "MyStethi has been a valuable partner in physician recruitment. Their customer service team is responsive and easy to work with, and ",
      highlight: "the platform has enabled us to connect with providers we may have otherwise missed",
      quoteEnd: ". In a competitive and challenging recruitment environment, MyStethi offers an important way to broaden our reach.",
      name: "Amy Knox",
      title: "Senior Sourcing Strategist",
      organization: "Medical University of South Carolina Health",
      avatar: "/static/images/avatars/amy-knox.jpg",
      highlightColor: {
        background: theme.palette.success.light,
        text: theme.palette.success.dark
      }
    },
    {
      id: 3,
      quote: "We've enjoyed using the platform. It's simple and streamlined and has delivered ",
      highlight: "quality, actionable candidates that our company has interviewed and considering hiring",
      quoteEnd: ". It has been a pleasant surprise in our recruiting toolbox.",
      name: "Jacob Stephenson",
      title: "Senior Director, Provider Recruiting",
      organization: "United Digestive",
      avatar: "/static/images/avatars/jacob-stephenson.jpg",
      highlightColor: {
        background: theme.palette.error.light,
        text: theme.palette.error.dark
      }
    }
  ]

  return (
    <Box sx={{ py: 10, backgroundColor: 'white' }}>
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="overline"
            sx={{
              color: theme.palette.grey[900],
              fontWeight: 600,
              fontSize: '0.9rem',
              letterSpacing: '0.1em',
              mb: 2,
              display: 'block'
            }}
          >
            TESTIMONIALS
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              color: theme.palette.grey[900],
              fontSize: { xs: '2rem', md: '2.5rem' },
              lineHeight: 1.2
            }}
          >
            We're Changing The<br />
            Hiring Experience
          </Typography>
        </Box>

        {/* Testimonials Grid */}
        <Grid container spacing={6}>
          {testimonials.map((testimonial) => (
            <Grid item xs={12} md={4} key={testimonial.id}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  minHeight: { xs: 'auto', md: '400px' }
                }}
              >
                {/* Quote Icon */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: '3rem',
                      color: theme.palette.primary.main,
                      fontWeight: 'bold',
                      lineHeight: 1,
                      fontFamily: 'serif'
                    }}
                  >
                    "
                  </Typography>
                </Box>

                {/* Quote Text with Highlighting */}
                <Box sx={{ mb: 4, flexGrow: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.grey[900],
                      fontSize: '1rem',
                      lineHeight: 1.6,
                      fontStyle: testimonial.isPlaceholder ? 'normal' : 'italic',
                      opacity: testimonial.isPlaceholder ? 0.7 : 1
                    }}
                  >
                    {testimonial.quote}
                    <Box
                      component="span"
                      sx={{
                        backgroundColor: testimonial.highlightColor.background,
                        color: testimonial.highlightColor.text,
                        px: 0.5,
                        py: 0.25,
                        borderRadius: '4px',
                        fontWeight: 600,
                        fontStyle: 'normal'
                      }}
                    >
                      {testimonial.highlight}
                    </Box>
                    {testimonial.quoteEnd}
                  </Typography>
                </Box>

                {/* Author Info - Fixed at bottom */}
                <Box sx={{ mt: 'auto' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      src={testimonial.avatar}
                      sx={{
                        width: 48,
                        height: 48,
                        mr: 2,
                        backgroundColor: theme.palette.primary.light
                      }}
                    >
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.grey[900],
                          mb: 0.5,
                          fontSize: '1rem'
                        }}
                      >
                        {testimonial.name}
                      </Typography>
                      {testimonial.title && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: theme.palette.grey[900],
                            opacity: 0.7,
                            mb: 0.25,
                            fontSize: '0.9rem'
                          }}
                        >
                          {testimonial.title}
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        sx={{
                          color: theme.palette.grey[900],
                          opacity: 0.6,
                          fontSize: '0.85rem'
                        }}
                      >
                        {testimonial.organization}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default TestimonialsSection
